"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fallback = void 0;
var tslib_1 = require("tslib");
var ui_text_1 = require("@hopin-team/ui-text");
var ui_visually_hidden_1 = require("@hopin-team/ui-visually-hidden");
var react_1 = tslib_1.__importDefault(require("react"));
var fallback_1 = require("../styled/fallback");
var root_1 = require("../styled/root");
var signal_1 = require("../styled/signal");
var getInitial = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName;
    var initial = '';
    if (firstName && lastName) {
        initial = "".concat(firstName[0]).concat(lastName[0]);
    }
    else if (firstName) {
        initial = "".concat(firstName[0]);
    }
    else if (lastName) {
        initial = "".concat(lastName[0]);
    }
    return initial;
};
var Fallback = function (_a) {
    var firstName = _a.firstName, isOnline = _a.isOnline, isOnlineText = _a.isOnlineText, lastName = _a.lastName, scale = _a.scale, size = _a.size, alt = _a.alt;
    var a11yProps = {};
    // When alt text is empty because the avatar is decorative and has adjacent text,
    // the avatar is hidden from screen readers to prevent repetitive announcements
    if (alt === '') {
        a11yProps['aria-hidden'] = true;
    }
    // When the avatar is standalone and has meaningful alt text,
    // we add it as an aria-label for screen readers
    if (alt !== '') {
        a11yProps['aria-label'] = alt;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(fallback_1.Fallback, tslib_1.__assign({}, a11yProps),
            react_1.default.createElement(ui_text_1.Text, { color: "grey-white", scale: (scale && scale > 10 ? 10 : scale) || (size && root_1.Sizes[size]) }, getInitial({ firstName: firstName, lastName: lastName })),
            isOnline && react_1.default.createElement(ui_visually_hidden_1.VisuallyHidden, null, isOnlineText)),
        isOnline && react_1.default.createElement(signal_1.Signal, { pattern: "success", sizeOption: size })));
};
exports.Fallback = Fallback;
//# sourceMappingURL=fallback.js.map